<template>
	<div class="box query">
		<el-form :model="query" ref="queryRef" :inline="true">
			<el-form-item>
				<el-input
					v-model="query.title"
					style="width: 150px"
					placeholder="题目标题"
					clearable
					@keyup.enter="onSearch"
				></el-input>
			</el-form-item>
			<el-form-item>
				<el-select
					v-model="query.po_id"
					placeholder="公职类型"
					style="width: 150px"
					clearable
					filterable
				>
					<el-option
						v-for="item in officList"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					/>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-cascader
					:options="typeList"
					clearable
					filterable
					:props="props"
					v-model="query.type_ids"
					placeholder="题库类型"
					@clear="clearCascader"
					style="width: 150px"
				></el-cascader>
			</el-form-item>
			<el-form-item>
				<el-select
					v-model="query.flag"
					placeholder="题目类型"
					style="width: 150px"
					clearable
					filterable
				>
					<el-option
						v-for="item in timuType"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					/>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSearch" icon="search">查询</el-button>
			</el-form-item>
		</el-form>
	</div>
  <div class="box data">
	<el-table
		ref="multipleTable"
		v-loading="loading"
		:data="tableData.data"
		row-key="id"
		border
		stripe
		style="width: 100%; height: 350px"
		:header-cell-style="{ background: 'var(--el-fill-color-light)' }"
		@selection-change="onSelectionChange"
	>
		<el-table-column reserve-selection type="selection" width="55" fixed="left"></el-table-column>
		<dc-table-column v-for="item in tableProps" :key="item" :item="item"></dc-table-column>
	</el-table>
  </div>
	<el-pagination
		v-if="total > 0"
		layout="prev, pager, next"
		:default-page-size="20"
		:total="total"
		@change="paginationChange"
	/>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useBaseMixins } from '@/views/base_mixins.js'
import { getSource } from '@/api/kaijiang/questionBank'
const model = defineModel({ type: Array, default: [] })
const { query, loading, tableData, selectionNodes } = useBaseMixins()
import { getpoList } from '@/api/kaijiang/officType'
import { getlistType } from '@/api/kaijiang/topicType.js'
import { getStype } from '@/api/kaijiang/common'
const total = ref(0)
const page = ref(1)
const multipleTable = ref(null)
const allowMult = ref(false)
const props = { label: 'name', value: 'id', children: 'child', checkStrictly: true }
const tableProps = ref([
	{
		label: '标题',
		prop: 'title',
		type: 'html',
		width: 300

		// fixed: 'left'
	},
	{
		label: '公职类型',
		prop: 'po_name'
	},
	{
		label: '题库类型',
		prop: 'type_name'
	},
	{
		label: '题目类型',
		prop: 'flag'
	}
])
const timuType = ref([])
//公职类型
const officList = ref([])
const typeList = ref([])

const getStypeList = async () => {
	const res = await getStype()
	res.data.forEach((item, index) => {
		timuType.value.push({
			label: item,
			value: item
		})
	})
}

const getpoAllList = async () => {
	const res = await getpoList({
		type: 'xuelian',
		flag: 'two'
	})
	res.data.forEach((item) => {
		officList.value.push({
			label: item.name,
			value: item.id
		})
	})
}
const clearCascader = () => {
	query.value.type_id = ''
}
const getTypeList = async () => {
	const res = await getlistType()
	typeList.value = res.data
}
/**
 * 选择
 * @param nodes
 */
function onSelectionChange(nodes) {
	selectionNodes.value = nodes
	model.value = nodes
}
const allData = ref([])
const getData = async (e) => {
	loading.value = true
	const res = await getSource(e)
	if (res.code === 1) {
		tableData.value.data = res.data.data
		loading.value = false
		total.value = res.data.total
		allData.value = JSON.parse(JSON.stringify(model.value))
		if (model.value.length > 0 && !allowMult.value) {
			model.value.forEach((item) => {
				const row = tableData.value.data.find((f) => f.id == item)
				if (row != undefined) {
					multipleTable.value.toggleRowSelection(row, true)
				}
			})
		}
	}
}
const getData2 = async (e) => {
	loading.value = true
	const res = await getSource(e)
	if (res.code === 1) {
		tableData.value.data = res.data.data
		loading.value = false
		total.value = res.data.total
		if (allData.value.length > 0 && !allowMult.value) {
			allData.value.forEach((item) => {
				const row = tableData.value.data.find((f) => f.id == item)
				if (row != undefined) {
					multipleTable.value.toggleRowSelection(row, true)
				}
			})
		}
		allowMult.value = true
	}
}
// 页数修改
const paginationChange = (val) => {
	page.value = val
	query.value.page = val
	allowMult.value = false
	getData2(query.value)
}
const onSearch = () => {
	query.value.page = 1
	if (query.value.type_ids && query.value.type_ids != '') {
		query.value.type_id = query.value.type_ids.toString()
	}

	getData(query.value)
}
onMounted(() => {
	allowMult.value = false
	getData({ page: page.value })
	getpoAllList()
	getTypeList()
	getStypeList()
})

onUnmounted(() => {})
</script>

<style scoped>
.query {
	margin-bottom: 20px;
}
</style>
